import { render, staticRenderFns } from "./MessageInputField.vue?vue&type=template&id=c1e33500"
import script from "./MessageInputField.vue?vue&type=script&lang=js"
export * from "./MessageInputField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports